import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { AlertService } from "ngx-alerts";

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { NgSelectConfig } from "@ng-select/ng-select";
import { Clientes } from '../cliente';
import { Inventario } from '../inventario';
import { Compras } from '../compras';
import { Producto } from '../producto';
import { Compradetalle } from '../compradetalle';
import { ViewChild } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { ProveedorService } from '../proveedor.service';
import { ComprasService } from '../compras.service';
import { UnidadService } from '../unidad.service';
import { ProductoService } from '../producto.service';
import { Unidades } from '../unidades';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-egreso',
  templateUrl: './egreso.component.html',
  styleUrls: ['./egreso.component.css']
})
export class EgresoComponent implements OnInit {
  cliente: Clientes= new Clientes();
  inventario: Inventario;
  events: Event[] = [];
  listaClientesActulizar: Clientes[]=[];
  ruc:string;
  compras: Compras;
  listCliene: Clientes[];
  productoSelecionado: Producto;
  listaCompras: Compras[] = [];
  compraDetalle: Compradetalle[] = [];
  listaBuscarProducto: Producto[] = [];
  compraDetall: Compradetalle;
  @ViewChild(MdbTablePaginationComponent)
  mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild("processingModal") public mdbModal: ModalDirective;
  subTotal: number;
  iva: number;
  url:string;
  urlSafe: SafeResourceUrl;
  total: number;
  
  porcentajeIva: number;

  constructor(
    private apiClie: ProveedorService,
    private ruter: Router,
    private formBuilder: FormBuilder,
    private apiCompras: ComprasService,
    private apiProducto: ProductoService,
    private alertService: AlertService,
    private apiUnidad: UnidadService,
   
    public sanitizer: DomSanitizer,
    private config: NgSelectConfig) {
      this.config.notFoundText = 'No se encuenta';
      this.config.appendTo = 'body';
      // set the bindValue to global config when you use the same 
      // bindValue in most of the place. 
      // You can also override bindValue for the specified template 
      // by defining `bindValue` as property
      // Eg : <ng-select bindValue="some-new-value"></ng-select>
      this.config.bindValue = 'value';
  
  }


  listarProductoParaBuscar(){
    this.apiProducto.getProducto(localStorage.getItem('id'))
    .subscribe((
      data: Producto[]) => {
      this.listaBuscarProducto = data;
    
    }
      , err => {
        console.log(err);
   
      });



  }

 
  buscarProducto() {
    let validar=0;
    this.compraDetalle.forEach(element => {
        if (this.productoSelecionado.codigoPrincipal==element.cod){
          let validar=1;
        }
    });
    if (validar==0){
    let codigoPrincipal=  this.productoSelecionado.codigoPrincipal
    if (codigoPrincipal!=null){
    this.apiProducto
      .getProductoPorCodigo(
        this.productoSelecionado.codigoPrincipal,
        localStorage.getItem("id")
      )
      .subscribe(
        (data: Producto[]) => {
          console.log(data);
          if (data.length > 0) {
          } else {
            //this.alertService.danger("No existe el producto...");
            //this.productoSelecionado.codigoPrincipal = null;
          }
          data.forEach((item) => {
            this.productoSelecionado = item;
            if (this.productoSelecionado == null) {
              this.alertService.danger("No existe el producto...");
              this.productoSelecionado.codigoPrincipal = null;
            } else {
            if(this.compras.tipoDoc=='E'){
              this.apiCompras
                .inventarioProducto(this.productoSelecionado.codigo)
                .subscribe((dataInv: Inventario) => {
                  console.log(dataInv);
                  if (dataInv.cantidad == null) {
                    this.alertService.danger("No hay stock...");
                    this.productoSelecionado.codigoPrincipal = null;
                  } else {
                    
                  }
                  if (dataInv.cantidad > 0) {
                
                    this.productoSelecionado.codigoPrincipal = null;
                    this.productoSelecionado.cantidad = 1;
                    this.compraDetall = new Compradetalle();
                    this.compraDetall.idProducto = this.productoSelecionado.codigo;
                    this.compraDetall.nombre = this.productoSelecionado.nombre;
                    this.compraDetall.cantidad = this.productoSelecionado.cantidad;
                    this.compraDetall.iva=this.productoSelecionado.iva;
                    //this.compraDetall.precioCosto=this.productoSelecionado.costo;
                    this.compraDetall.codigoPrincipal=codigoPrincipal;
                    this.compraDetalle.push(this.compraDetall);
                    this.mdbTable.setDataSource(this.compraDetalle);
                    this.mdbTable.dataSourceChange(); 
                    this.calcular();
                  }
                });
            }else{
              try {
                this.apiUnidad.getUnidad(this.productoSelecionado.idUnidad.toString())
                .subscribe(
                  (data: Unidades[]) => {
  
                    data.forEach((item) => {
                    console.log(data);
                    this.productoSelecionado.codigoPrincipal = null;
                this.productoSelecionado.cantidad = 1;
                this.compraDetall = new Compradetalle();
                this.compraDetall.idProducto = this.productoSelecionado.codigo;
                this.compraDetall.nombre = this.productoSelecionado.nombre;
                this.compraDetall.cantidad = this.productoSelecionado.cantidad;
                this.compraDetall.factor=item.factor;
                this.compraDetall.cod=codigoPrincipal
                this.compraDetall.descuento=0;
                //this.compraDetall.iva=this.productoSelecionado.iva;
                this.compraDetall.precioCosto=this.productoSelecionado.costo;
                //this.compraDetall.codigoPrincipal=codigoPrincipal;
                this.compraDetall.unidadCompra=item.descripcion;
                this.compraDetalle.push(this.compraDetall);
                this.mdbTable.setDataSource(this.compraDetalle);
                this.mdbTable.dataSourceChange();
                this.calcular();
                    })
                  }
                    , err => {
                      console.log(err);
                      
                    });  
              } catch (error) {
                
              }
              
             
            }
          }
          });
        },
        (err) => {
          this.alertService.danger("Problemas con la conexión");
        }
      );
    }
  }
  }
  valueChangeCantidad(compra: Compradetalle) {
    this.compraDetall = compra;
    this.compraDetall.total =
    this.compraDetall.cantidadPedida * this.compraDetall.precioCosto;
    this.compraDetall.cantidad= this.compraDetall.cantidadPedida *this.compraDetall.factor;
    this.calcular();
  }

  eliminar(numero: number) {
    //this.removeAllElements( this.listaProductos,numero);
    this.compraDetalle.splice(numero, 1);
    this.mdbTable.setDataSource(this.compraDetalle);
    this.mdbTable.dataSourceChange();
    this.calcular();
  }

 
    onChange(newValue) {
      console.log(newValue);
      this.compras.tipoDocMovi=newValue;
      this.calcular();
  }
  

  calcular() {
    if (this.compras.tipoCompra == 'F') {
      this.porcentajeIva = 0.12;
    } else {
      this.porcentajeIva = 0.0;
    }

    this.subTotal = 0.0;
    this.total = 0.0;

    this.compraDetalle.forEach((item) => {
      this.subTotal = this.subTotal + item.total;
    });
    this.iva=this.porcentajeIva*this.subTotal;
    this.total=this.iva+this.subTotal;
  }

onChange1($event: Event) {
    this.buscarCedula();
}

onChangeProducto($event: Event) {
  this.buscarProducto();
}
  listarProveedor()
 {
  this.apiClie
  .getClientes(
    localStorage.getItem("id")
  )
  .subscribe(
    (data: Clientes[]) => {
        this.listCliene=data;
        console.log(this.listCliene);
      });
    }


  

  buscarCedula() {
    this.apiClie
      .getCliente(
        this.ruc
      )
      .subscribe(
        (data: Clientes[]) => {
          data.forEach((item) => {
            this.cliente = item;

            if (this.cliente == null) {
              this.alertService.danger("No existe la cédula o Ruc");
              this.cliente.numeroidentificacion = null;
            }
          });
        },
        (err) => {
        //  this.alertService.danger("Problemas con la conexión");
        }
      );
  }

  limpiar() {
    this.cliente = new Clientes();
    this.compras = new Compras();
    this.compras.tipoCompra='E'
    this.productoSelecionado = new Producto();
    this.compraDetalle = [];
    this.mdbTable.setDataSource(this.compraDetalle);
    this.mdbTable.dataSourceChange();
  }

  ngOnInit() {
    this.listarProveedor();
    this.listarProductoParaBuscar();
    this.porcentajeIva = 0.0;
    this.limpiar();

 
   
  }

  nuevo() {
    this.limpiar();
  }




  actulizarDatosCliente() {
 
    if(confirm("Está seguro de actualizar")) {
      this.cliente.enviado='S';
    this.listaClientesActulizar[0] = this.cliente;
    this.apiClie.setActulizarCliente(this.listaClientesActulizar).subscribe(

      data  => {
        this.alertService.success("Se agrego un nuevo cliente");
        this.mdbModal.hide();
        this.listarProveedor();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
    }
  }



  guardar() {
    if(this.compras.tipoDocMovi==null || this.compras.tipoDocMovi==null){
      this.alertService.danger('Debe seleccionar tipo de egreso');
    }else if(this.compras.fecha==null || this.compras.fecha==null){
      this.alertService.danger('Debe seleccionar la fecha...');
    }else if(this.compraDetalle.length==0){
      this.alertService.danger('No hay productos ingresados......');
    }  else  {
    this.compras.id = 0;
    this.compras.idCliente = this.cliente.codcliente;
    this.compras.valorTotal=this.total;
    this.compras.valorIva=this.iva;
    this.compras.valorSubTotal=this.subTotal;
    this.compras.fechaP=this.compras.fecha
    this.compras.tipoCompra="E";
    this.compras.tipoDoc="E";
    this.compras.enviado="S";
    this.compras.det = this.compraDetalle;
    this.compras.idEmisor=  Number.parseInt (localStorage.getItem("id"));
    this.listaCompras[0] = this.compras;

    this.apiCompras.setActulizarCompras(this.listaCompras).subscribe(
      (data) => {
      
         
          console.log(data);
          this.url=environment.apiReportes+"movimientos.rptdesign&id="+data.id+"&__emitterid=org.eclipse.birt.report.engine.emitter.pdf";
          window.open(this.url, '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
          
          this.limpiar();
          this.ruter.navigate(['compras']);
         
      
      },
      (error) => {
        this.alertService.danger(error);
      }
    );
    }
  }
}
